module.exports = __webpack_public_path__ + "static/img/bg-star.2f2cb36c.png";